$(document).ready(function () {
  // Collection section slider
  let gridViewItemSlider = $(".neck-allure");
  gridViewItemSlider.slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: true,
    autoplay: false,
    adaptiveHeight: true,
    autoplaySpeed: 3000,
    speed: 500,
    rows: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  $(".accordion-head,.accordion-header").on("click", function () {
    $(this).next().slideToggle();
    $(this).toggleClass("active");
  });

  // Related articles
  if ($(window).width() < 750) {
    $(".related-articles-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      infinite: false
    });
  }

  // Add ID to H2 in article content
  $('.template-article .article__content > h2').each(function(){
    var articleID = $(this).text();
    articleID = articleID.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    $(this).attr('id', articleID);
    // console.log(articleID);
  });
});
